import isEqual from 'lodash.isequal';

export const isEmptyObject = (obj) => !obj || Object.keys(obj).length === 0;

export const isEqualObject = (obj, otherObj) => isEqual(obj, otherObj);

export const removeEmptyFields = (obj) => Object.keys(obj)
  .filter((k) => obj[k] != null && obj[k] !== '') // Remove undef. and null.
  .reduce(
    (newObj, k) => {
      if (typeof obj[k] === 'object') {
        return Array.isArray(newObj)
          ? [...newObj, removeEmptyFields(obj[k])]
          : { ...newObj, [k]: removeEmptyFields(obj[k]) };
      }
      return Array.isArray(newObj)
        ? [...newObj, obj[k]]
        : { ...newObj, [k]: obj[k] }; // Copy value
    },
    Array.isArray(obj) ? [] : {},
  );
